import { render, staticRenderFns } from "./CompanyInfoForm.vue?vue&type=template&id=251204cf&scoped=true&"
import script from "./CompanyInfoForm.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyInfoForm.vue?vue&type=style&index=0&id=251204cf&scoped=true&lang=scss&"
import style1 from "./CompanyInfoForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251204cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VImg,VRow,VSelect,VTextField})
